import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dc-pricing-include',
  templateUrl: './pricing-include.component.html',
  styleUrls: ['./pricing-include.component.scss']
})
export class PricingIncludeComponent implements OnInit {
  features = [
    {
      icon: 'airplay',
      title: 'Múltiples formas de fichar',
      mensaje:
        'Con HORAX3 puede fichar desde la app móvil, una Tablet, a través de la página Web, o desde nuestros dispositivos sin contacto fisico.'
    },
    {
      icon: 'box',
      title: 'Módulos',
      mensaje:
        'Incluye los módulos necesarios para la gestión de recursos humanos. Puede personalizarse según las necesidades de cada departamento.'
    },
    {
      icon: 'Calendar',
      title: 'Gestión de vacaciones',
      mensaje:
        'La plantilla puede solicitar los días de vacaciones, asuntos propios o cualquier otro motivo de ausencia de su lugar de trabajo.. '
    },
    {
      icon: 'lock',
      title: 'Sus datos seguros',
      mensaje:
        'Guarde la información en la nube de forma segura, cumpliendo con la normativa de protección de datos UE 2016/679 y LO 3/2018.'
    },
    {
      icon: 'headphones',
      title: 'Soporte',
      mensaje:
        'Siempre contará con la ayuda y la atención personalizada necesarias ante cualquier duda, de esta forma facilitaremos el uso de la aplicación.'
    },
    {
      icon: 'monitor',
      title: 'Formación personalizada',
      mensaje:
        'Tiene múltiples vídeos de formación a su disposición para consultar en cualquier momento y si lo necesita, se le dará una formación personalizada.'
    }
  ];

  constructor() {}

  ngOnInit() {}
}
